<script>
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  props: {
    chartdata: Array,
    options: Array,
    color: Array,
    areaColor: String,
  },
  data() {
    return {
      gradient: null,
      gradient2: null,
    };
  },
  mounted() {
    // console.log(this.chartdata);
    this.gradient = this.$refs.canvas
      .getContext("2d")
      .createLinearGradient(0, 0, 0, 230);
    let gradientStep1 = this.color[0];
    let gradientStep2 = this.color[0] + "7a";
    let gradientStep3 = this.color[0] + "00";

    this.gradient.addColorStop(0, gradientStep1);
    this.gradient.addColorStop(0.5, gradientStep2);
    this.gradient.addColorStop(1, gradientStep3);

    this.gradient2 = this.$refs.canvas
      .getContext("2d")
      .createLinearGradient(0, 0, 0, 230);
    let gradientStep4 = this.color[1];
    let gradientStep5 = this.color[1] + "7a";
    let gradientStep6 = this.color[1] + "00";

    this.gradient2.addColorStop(0, gradientStep4);
    this.gradient2.addColorStop(0.5, gradientStep5);
    this.gradient2.addColorStop(1, gradientStep6);

    this.renderChart(
      {
        labels: this.chartdata.labels,
        datasets: [
          {
            backgroundColor: this.color[0],
            data: this.chartdata.value,
            borderWidth: 1.5,
            borderColor: this.color[0],
            backgroundColor: this.gradient,
            pointBorderWidth: 1,
          },
          {
            backgroundColor: this.color[1],
            data: this.chartdata.value2,
            borderWidth: 1.5,
            borderColor: this.color[1],
            backgroundColor: this.gradient2,
            pointBorderWidth: 1,
          },
        ],
      },
      {
        maintainAspectRatio: false,
        responsive: true,
        legend: false,
        scales: {
          yAxes: [
            {
              // id: "A",
              ticks: {
                beginAtZero: true,
                steps: 10,
                stepValue: 5,
                max: 30,
              },
              // position: "left",
              scaleLabel: {
                display: false,
                labelString: this.chartdata.tooltip_label,
              },
            },
          ],
      
        },
      }
    );
  },
  computed: {
    chartData: function () {
      console.log("chartData");
      return this.data;
    },
  },
};
</script>

<style scoped>
.cardBorder {
  border-radius: 20px;
}
.cardBordercolor {
  border-radius: 35px;
  border-style: solid;
  border-color: #6fda79;
}
.stack {
  position: relative;
  top: 15px;
  right: 110px;
}
</style>